import React from "react";
import { Link } from "react-router-dom";

/**
 * 403 response handling. Explains WHY (role + missing permission), never leaks the data,
 * and offers the two safe next steps: go back, or request access.
 */
export default function PermissionDenied({ required, role, resource = "this resource", requestId, backTo = "/", onRequestAccess, compact = false }) {
  return (
    <div className={`state-panel state-denied${compact ? " compact" : ""}`} role="alert" data-state-kind="permission">
      <div className="state-icon"><i className="bi bi-shield-lock" aria-hidden="true"></i></div>
      <h6 className="state-title">You don't have access to {resource}</h6>
      <p className="state-desc">
        {role ? `Your role (${role}) doesn't include this permission.` : "Your role doesn't include this permission."}{" "}
        Ask a workspace admin to grant it.
      </p>
      {required && <div className="mb-3"><code className="permission-chip">{required}</code></div>}
      <div className="state-actions">
        <Link className="btn btn-outline-primary btn-sm" to={backTo}>Back to overview</Link>
        {onRequestAccess && <button type="button" className="btn btn-primary btn-sm" onClick={onRequestAccess}>Request access</button>}
      </div>
      {requestId && <div className="state-meta"><span>HTTP 403</span><span>{requestId}</span></div>}
    </div>
  );
}
